import api from './api';
const BASE = '/transactiontikanesenp';

export default {
  listByAccount: (tiKaneSenpId, params = {}) =>
    api.get(`${BASE}/by-account/${tiKaneSenpId}`, {
      params: { functionCode: 'TRANS_VIEW', ...params },
    }).then((r) => r.data),

  deposit: (tiKaneSenpId, data) =>
    api.post(`${BASE}/${tiKaneSenpId}/deposit`, { ...data, functionCode: 'TRANS_DEPOSIT' }).then((r) => r.data),

  withdraw: (tiKaneSenpId, data) =>
    api.post(`${BASE}/${tiKaneSenpId}/withdraw`, { ...data, functionCode: 'TRANS_WITHDRAW' }).then((r) => r.data),
};
